export const reportError = (message, context = {}) => {
    const body = JSON.stringify({ level: 'error', message: ('JS ERROR: ' + String(message)).slice(0, 2000), context });
    if (typeof navigator.sendBeacon === 'function') {
        navigator.sendBeacon('/api/frontend-logs', new Blob([body], { type: 'application/json' }));
    }
};

window.addEventListener('error', (e) => {
    reportError(e.message, { url: location.href, stack: e.error?.stack, userAgent: navigator.userAgent });
});
window.addEventListener('unhandledrejection', (e) => {
    reportError(String(e.reason), { url: location.href, userAgent: navigator.userAgent });
});
